import { computed, defineComponent, onMounted, PropType, watch } from 'vue';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';
import { ProjectResultAction, ProjectResultGetter } from '@/store/projectResult/projectResult.module';
import { ProjectSummary } from '@/store/projectResult/projectResult.model';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import { Region } from '@/store/region/region.model';
import LoadingComponent from '@/components/loading/Loading.vue';
import projectResultService from '@/store/projectResult/projectResult.service';

export default defineComponent({
  name: 'ProjectMinisterSummaryComponent',
  components: {
    LoadingComponent
  },
  props: {
    fiscalYear: {
      type: Object as PropType<FiscalYear>
    },
    region: {
      type: Object as PropType<Region>
    },
    isFile: {
      type: Boolean,
      default: false,
    }
  },
  setup: (props) => {
    const toast = useToast();
    const store = useStore();
    const summary = computed<ProjectSummary>(() => store.getters[ProjectResultGetter.SUMMARY]);
    const isLoading = computed(() => store.getters[ProjectResultGetter.STATUS] === 'init' || store.getters[ProjectResultGetter.STATUS] === 'loading');

    onMounted(() => {
      if (props.fiscalYear && props.region) {
        store.dispatch(ProjectResultAction.GET_REGION_SUMMARY, {
          fiscalYearId: props.fiscalYear?.id,
          regionId: props.region?.id,
        });
      }
    });

    watch(() => [props.fiscalYear, props.region], ([fiscalYear, region]) => {
      if (props.fiscalYear && props.region) {
        store.dispatch(ProjectResultAction.GET_REGION_SUMMARY, {
          fiscalYearId: fiscalYear?.id,
          regionId: region?.id,
        });
      }
    });

    const pdfClick = () => {
      projectResultService.GetRegionPdf(props.fiscalYear?.id as number, props.region?.id as number)
        .then((response) => {
          const a = document.createElement('a'); //Create <a>
          document.body.appendChild(a);
          a.style.display = 'none';
          a.href = window.URL.createObjectURL(response.data); //'data:pdf/application;base64,' + response.data; //Image Base64 Goes here
          a.download = (`ข้อมูลภาพรวมของ${props.region?.shortName}_${props.fiscalYear?.name.replace(' ', '_')}.pdf`); //File name Here
          a.click(); //Downloaded file
        })
        .catch(() => {
          toast.error('ไม่สามารถเรียกข้อมูลได้');
        });
    };

    const excelClick = () => {
      projectResultService.GetRegionExcel(props.fiscalYear?.id as number, props.region?.id as number)
        .then((response) => {
          const a = document.createElement('a'); //Create <a>
          document.body.appendChild(a);
          a.style.display = 'none';
          a.href = window.URL.createObjectURL(response.data); //'data:pdf/application;base64,' + response.data; //Image Base64 Goes here
          a.download = (`ข้อมูลโครงการของ${props.region?.shortName}_${props.fiscalYear?.name.replace(' ', '_')}.xlsx`); //File name Here
          a.click(); //Downloaded file
        })
        .catch(() => {
          toast.error('ไม่สามารถเรียกข้อมูลได้');
        });
    };

    return {
      summary,
      isLoading,
      pdfClick,
      excelClick,
    };
  }
});
